import store from './vuex/store'
import Vue from 'vue'
import router from './router'
import utils from './tools/utils'

/**
 * 监听每次路由的跳转
 * 通过loginInfo判断是否登录
 */
router.beforeEach(async (to, from, next) => {
  if (Vue.prototype.$debug) console.log('Full Path----->' + to.fullPath)
  // 页面切换显示loading
  store.commit('updateLoadingStatus', {
    isLoading: true
  })

  // 单独配置宁乡小程序的二级域名
  const isNingXiangApp = window.location.href.indexOf('ningxiang-apps') > -1

  // 通过DS桥去调用APP的用户信息，如果能拿到信息，就证明是从知会小程序过来的，productCode以这个为准
  let flag = true
  if (!isNingXiangApp) {
    dsBridge.call(
      'getBaseInfo',
      await function(res) {
        let RES = JSON.parse(res)
        if (RES) {
          flag = false
          // console.log('获取人员信息：', RES)
          sessionStorage.setItem('productName', RES.product_code)
          store.commit('setProductName', RES.product_code)
          next()
        }
      }
    )
  } else {
    next()
  }

  // 本地开发
  setTimeout(() => {
    if (flag && (process.env.NODE_ENV === 'development' || Vue.prototype.localDev)) {
      sessionStorage.setItem('productName', Vue.prototype.devVar.users.product_code)
      store.commit('setProductName', Vue.prototype.devVar.users.product_code)
      next()
    }
  }, 1000)

  // 判断是否有路由数据，没有则从接口拉取最新的路由数据
  // const productName = sessionStorage.getItem('productName')
  // if (!sessionStorage.getItem('router') && localStorage.getItem(productName)) {
  //   await getRouters()
  // }
})

router.afterEach(function(to) {
  store.commit('updateLoadingStatus', {
    isLoading: false
  })
})

// 获取路由信息
async function getRouters() {
  let product = sessionStorage.getItem('productName')
  let routerData = await Vue.prototype.http.get(
    '/static/config/' + product + '/permission-' + product + '.json',
    '',
    'noApi'
  )
  sessionStorage.setItem('router', JSON.stringify(routerData))
  Vue.prototype.router.addRoutes(Vue.prototype.utils.dynamicRouter(routerData))
}



// WEBPACK FOOTER //
// ./src/refresh-init.js